import { reskinStyles } from '../theme-variant';
const overrideCheckbox = (theme) => {
  theme.overrides.MuiCheckbox = {
    colorSecondary: {
      color: theme.colorPalette.green_75,
      // Reskin: neutral empty boxes, bark when checked.
      ...reskinStyles(theme, {
        color: theme.colorPalette.beige_90,
        '&$checked': { color: theme.colors.selection_control }
      }),
      '&$disabled': {
        color: theme.colorPalette.beige_25,
        opacity: 0.6
      }
    },
    colorPrimary: {
      color: theme.colors.selection_control,
      ...reskinStyles(theme, { color: theme.colorPalette.beige_90 }),
      position: 'relative',
      '&::before': {
        content: '" "',
        display: 'block',
        height: 16,
        width: 16,
        float: 'left'
      },
      '& >span': {
        position: 'absolute'
      },
      '&$checked': {
        color: theme.colors.selection_control
      },
      '&$checked::before': {
        backgroundColor: theme.colorPalette.white
      },
      '&$disabled': {
        color: theme.colorPalette.beige_25,
        opacity: 0.6,
        '&$checked': {
          color: theme.colors.selection_control
        }
      }
    },
    root: {
      marginTop: 0
    }
  };
};

export default overrideCheckbox;
